import {
  GetAudioComponentDocument,
  GetAudioComponentQuery,
  GetAudioComponentQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getAudioComponent(id: string, locale: string) {
  return client.query<GetAudioComponentQuery, GetAudioComponentQueryVariables>({
    query: GetAudioComponentDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
